import { initAddToCartButtons } from 'javascripts/watcher/magic-matze-cart';
import store from 'store/dist/store.modern';
import CustomEvent from 'custom-event';
import Cookies from 'js-cookie';
import initChatbot from './chatbot';
import initFigure from '../../components/molecules/figure/figure';
import initSocialEmbed from '../../components/molecules/social-embed/social-embed';
import initSocialWall from '../../components/molecules/social-wall/social-wall';

const COOKIESTATUS = {
  ACCEPT: 'accept',
  DECLINE: 'decline',
};

const COOKIES = {
  MARKETING: [
    {
      name: 'bawu-youtube',
      expires: undefined,
    },
    {
      name: 'bawu-instagram',
      expires: undefined,
    },
    {
      name: 'bawu-vimeo',
      expires: undefined,
    },
    {
      name: 'bawu-facebook',
      expires: undefined,
    },
    {
      name: 'bawu-twitter',
      expires: undefined,
    },
    {
      name: 'bawu-mastodon',
      expires: undefined,
    },
    {
      name: 'bawu-soundcloud',
      expires: undefined,
    },
    {
      name: 'bawu-datawrapper',
      expires: undefined,
    },
  ],
  CONSENT: [
    {
      name: 'bawu-consent',
      expires: undefined,
    },
    {
      name: 'bawu-social-wall',
      expires: undefined,
    },
    {
      name: 'bawu-chatbot',
      expires: undefined,
    },
    {
      name: 'fontsLoaded',
      expires: undefined,
    },
  ],
};

document.querySelectorAll('.js-cookie-alert').forEach(($alert) => {
  const $clone = document.importNode($alert.content, true);

  const onConsent = ($cookieAlert) => {
    $cookieAlert.remove();

    const $cookiesTechnical = $cookieAlert.querySelector('#cookie-neccessary');
    const $cookiesMarketing = $cookieAlert.querySelector('#cookie-marketing');

    // Marketing cookies
    if ($cookiesMarketing && $cookiesMarketing.checked) {
      Object.keys(COOKIES.MARKETING).forEach((key) => {
        Cookies.set(COOKIES.MARKETING[key].name, COOKIESTATUS.ACCEPT, { path: '/' });
      });

      initFigure();
      initSocialEmbed();
    }

    // Necessary cookies
    if ($cookiesTechnical && $cookiesTechnical.checked) {
      Object.keys(COOKIES.CONSENT).forEach((key) => {
        Cookies.set(COOKIES.CONSENT[key].name, COOKIESTATUS.ACCEPT, { path: '/' });
        store.set(COOKIES.CONSENT[key], true);
      });

      initChatbot();
      initSocialWall();
    }

    initAddToCartButtons();

    const cookieAcceptEvent = new CustomEvent('cookieAccepted', {
      bubbles: true,
    });
    document.dispatchEvent(cookieAcceptEvent);
  };

  if (Cookies.get('bawu-consent') !== COOKIESTATUS.ACCEPT) {
    document.body.appendChild($clone);
    const $cookieAlert = document.querySelector('.cookie-alert');
    const $submitBtn = $cookieAlert.querySelector('.cookie-alert__button .button');

    if ($submitBtn) {
      $submitBtn.addEventListener('click', () => onConsent($cookieAlert));
    }
  }
});
